import { MaskEnum } from "./enum/mask.enum";

export const applyMask = (
    text: string,
    type: MaskEnum
  ) => {
    let maskedText = text.replace(/\D/g, "");
    switch (type) {
      case MaskEnum.CPF:
        maskedText = maskedText
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        break;
      case MaskEnum.CNPJ:
        maskedText = maskedText
          .replace(/(\d{2})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d{1,4})/, "$1/$2")
          .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
        break;
        
      case MaskEnum.CEP:
        maskedText = maskedText.replace(/(\d{2})(\d{3})(\d{1,3})$/, "$1$2-$3");
        break;
  
      case MaskEnum.PHONE:
        maskedText = maskedText
          .replace(/(\d{2})(\d)/, "($1)$2")
          .replace(/(\d{5})(\d{1,4})$/, "$1-$2");
        break;
  
      case MaskEnum.MONEY:
        maskedText = `R$: ${(Number(text.replace(/\D/g, "")) / 100)
          .toFixed(2)
          .replace(".", ",")}`;
        break;
      case MaskEnum.DATE:
        maskedText = maskedText
          .replace(/(\d{2})(\d)/, "$1/$2")
          .replace(/(\d{2})(\d{1,4})$/, "$1/$2");
        break;
      case MaskEnum.TIME:
        maskedText = maskedText.replace(/(\d{2})(\d{1,2})$/, "$1:$2");
        break;
      case MaskEnum.PERCENTAGE:
        maskedText = maskedText.replace(/(\d+(\.\d*)?)/, "$1%");
        break;
      case MaskEnum.NONE:
        maskedText = text;
        break;
      default:
        maskedText = text;
        break;
    }
    return maskedText;
  };